module.exports = __webpack_public_path__ + "img/cowname.fba57881.png";